import React from 'react';

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


class ShowError extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){

        if (this.props.error){

            let invalidFields = {};
            let errorMessage = {};

            if (this.props.error.response){
                if (this.props.error.response.data){
                    if (this.props.error.response.data.message){
                        errorMessage = this.props.error.response.data.message;
                    }
                    if (this.props.error.response.data.fields){
                        invalidFields = this.props.error.response.data.fields
                    }
                }
            }

            return(
                <>
                    {errorMessage && <p>{errorMessage}</p>}
                    {
                        Object.keys(invalidFields).map(
                        (field, pos) => 
                            {
                                let error = invalidFields[field].error;
                                return <p key={pos}>{field}:{error}</p>
                            }
                        )
                    }
                </>
            )
        }

        if (this.props.errorMessage){
            return(
                <p>{this.props.errorMessage}</p>
            )
        }

        return "ERROR - Failed to Update";

    }
}

export default function ShowError_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ShowError {...props} navigation={navigation} location={location} params={params} />;
  }
